import styled from '@emotion/styled';

interface propTypes {
  children: any;
  onDismiss: any;
}

const BottomCenterToastType1 = ({ children, onDismiss }: propTypes) => {
  return (
    <Toast>
      <p>{children}</p>
    </Toast>
  );
};

export default BottomCenterToastType1;

const Toast = styled.div`
    background: rgba(0, 0, 0, 0.8);
    border-radius: 50px;
    display: inline-block;
    position: fixed;
    z-index: 1;
    width: 60vw;
    padding: 15px 20px;
    text-align: center;
    max-width: 310px;
    box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.1),
      0 2px 15px 0 rgba(0, 0, 0, 0.05);
    right: 0;
    left: 0;
    margin: auto;
    animation-name: toastBounceUp;
    -webkit-animation-name: toastBounceUp;
    animation-duration: 0.7s;
    -webkit-animation-duration: 0.7s;
    bottom: 4.5rem;

    & > p {
      font-size: 1rem;
      color: #fff;
      font-weight: 400;
      display: inline-block;
      line-height: normal;
      letter-spacing: -0.2px;
    }
  }

  @keyframes toastBounceUp {
    from,
    60%,
    75%,
    90%,
    to {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }
    from {
      opacity: 0;
      transform: translate3d(0, 3000px, 0);
    }
    60% {
      opacity: 1;
      transform: translate3d(0, 25px, 0);
    }
    75% {
      transform: translate3d(0, -10px, 0);
    }
    90% {
      transform: translate3d(0, 5px, 0);
    }
    to {
      transform: translate3d(0, 0, 0);
    }
  
`;
